export default __webpack_public_path__ + "static/media/fw-evelyn-er-Rose Gold.ae0879f8.mp4";